class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();

      // Check for parent container (cart-items or cart-drawer-items)
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      const line = this.dataset.index; // Line index for the item

      if (!cartItems || !line) {
        console.error("Cart items or line index is missing.");
        return;
      }

      cartItems.updateQuantity(line, 0); // Remove the item by setting quantity to 0
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  getSectionsToRender() {
    const mainCartItems = document.getElementById("main-cart-items");
    const mainCartFooter = document.getElementById("main-cart-footer");

    return [
      {
        id: "main-cart-items",
        section: mainCartItems?.dataset.id || null,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: mainCartFooter?.dataset.id || null,
        selector: ".js-contents-2",
      },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      { id: "cart-icon-bubble-mobile", section: "cart-icon-bubble-mobile", selector: ".shopify-section" },
      { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
    ].filter((section) => section.section);
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const sectionsToRender = this.getSectionsToRender();

    if (sectionsToRender.length === 0) {
      console.error("No sections to render. Check your HTML structure or data-id values.");
      this.disableLoading(line);
      return;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch('/cart/change.js', { // Hardcoded for testing
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        sectionsToRender.forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        });
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  enableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    cartItemElements.forEach((overlay) => overlay.classList.remove("hidden"));
  }

  disableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
  }

  getSectionInnerHTML(html, selector) {
    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");
    const element = document.querySelector(selector);

    if (!element) {
      console.error(`Selector "${selector}" not found in the response.`);
      return "";
    }

    return element.innerHTML;
  }
}
customElements.define("cart-items", CartItems);
